// Labels die Maße beschreiben — werden aus Spec-Filter-Chips herausgefiltert
// (gehören zum "Maße"-Filter, nicht zu freien Spec-Chips)
const DIMENSION_LABELS = new Set([
  "breite",
  "höhe",
  "tiefe",
  "länge",
  "durchmesser",
  "gewicht",
  "breite (b)",
  "höhe (h)",
  "tiefe (t)",
]);

/**
 * Parst metadata.specifications — Format: "Label:Wert | Label:Wert | ..."
 * Gibt Record<label, string[]> zurück (Maß-Labels ausgeschlossen).
 */
export function parseSpecifications(
  raw: string | null | undefined,
): Record<string, string[]> {
  if (!raw) return {};
  const result: Record<string, string[]> = {};
  for (const part of String(raw).split(/\s*\|\s*/)) {
    const colonIdx = part.indexOf(":");
    if (colonIdx === -1) continue;
    const rawLabel = part.slice(0, colonIdx).trim();
    const val = part.slice(colonIdx + 1).trim();
    if (!val || !rawLabel) continue;
    if (DIMENSION_LABELS.has(rawLabel.toLowerCase())) continue;
    if (!result[rawLabel]) result[rawLabel] = [];
    if (!result[rawLabel].includes(val)) result[rawLabel].push(val);
  }
  return result;
}
